import { trackEvent } from './trackEvent';
import { isAlloyReady } from './alloy';
import { AnalyticsVariableNames, eventMap, variableMap } from './types';

const toString = (value) => String(value);

/**
 * Track a voiceover-related event using Adobe Alloy
 *
 * @param {string} eventName - One of AnalyticsEventNames' voiceover events
 * @param {Object} data
 * @param {{ email: string }} data.user
 * @param {string|number} [data.videoId]
 * @param {string|number} [data.templateId]
 * @param {string} [data.voiceoverTemplate]
 */
export const trackVoiceoverEvent = (eventName, data = {}) => {
  if (typeof window === 'undefined' || !data?.user?.email) {
    return;
  }

  try {
    if (!isAlloyReady()) {
      return;
    }

    const props = {
      [variableMap[AnalyticsVariableNames.USER_EMAIL]]: toString(data.user.email),
      [variableMap[AnalyticsVariableNames.TIMESTAMP]]: toString(new Date().toISOString()),
    };

    if (data.videoId) {
      props[variableMap[AnalyticsVariableNames.VIDEO_ID]] = toString(data.videoId);
    }

    if (data.templateId) {
      props[variableMap[AnalyticsVariableNames.TEMPLATE_ID]] = toString(data.templateId);
    }

    if (data.voiceoverTemplate) {
      props[variableMap[AnalyticsVariableNames.VOICEOVER_TEMPLATE]] = toString(
        data.voiceoverTemplate,
      );
    }

    trackEvent(eventMap[eventName], props);
  } catch (error) {
    console.error('Failed to track voiceover event:', error);
  }
};
